import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import PromotionItem from "./promotionItem";

const ActivePromotion = () => {
  return (
    <Container>
      <Typography size="2xl" weight="bold" mb="3.2">
        Active Promotions
      </Typography>
      <TableContainer>
        <thead>
          <tr>
            <th scope="col">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  paddingLeft: "2rem"
                }}
              >
                <Typography size="s" weight="semibold" mr="0.4">
                  Track / Video
                </Typography>
              </div>
            </th>
            <th scope="col">
              <Typography size="s" weight="medium" mr="0.4">
                Promotion Type
              </Typography>
            </th>
            <th scope="col">
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography size="s" weight="semibold" mr="0.4">
                  Status
                </Typography>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {/* {songs?.map((song, i) => {
            if (i > 4) {
              return null;
            }
            return <TrackListItem data={song} key={i} />;
          })} */}
          <PromotionItem />
        </tbody>
      </TableContainer>
    </Container>
  );
};

export default ActivePromotion;

const Container = styled.div`
  margin-top: 10rem;
`;

const TableContainer = styled.table`
  margin-bottom: 6.4rem;
  width: 100%;
  color: white;
  border-collapse: collapse;
  @media only screen and (max-width: 769px) {
    width: 100rem;
    overflow: scroll;
  }

  tr {
    background-color: transparent;
    position: relative;
    &:nth-child(odd) {
      background-color: ${Colors.grey700};
    }
  }
  th {
    text-align: left;
    color: ${Colors.grey500};
    padding: 1.65rem 0;
    background-color: ${Colors.grey900};
    cursor: auto;
  }

  td {
    color: #e4e4e4;
    padding: 1.2rem 0;
  }
`;
